import produce from 'immer';
import React from 'react';
import { getOrganizationById } from '../../../apis/organization';
import {
  IOrganizationContext,
  OrganizationContext,
} from '../../../contexts/organization';
import { IOrganization } from '../../../modules/unsw-fhir/Organization';

export type OrganizationProviderProps = {
  organizationId?: string;
};

export type OrganizationProviderState = IOrganizationContext;

export default class OrganizationProvider extends React.PureComponent<
  OrganizationProviderProps,
  OrganizationProviderState
> {
  constructor(props: OrganizationProviderProps) {
    super(props);

    this.state = {
      getOrganizationName: this.getOrgnizationName,
      setOrganization: this.setOrganization,
    };
  }

  componentDidMount = async () => {
    return await this.updateOrganization();
  };

  componentDidUpdate = async (pProps: OrganizationProviderProps) => {
    if (pProps.organizationId !== this.props.organizationId)
      return await this.updateOrganization();
  };

  render = () => {
    return (
      <OrganizationContext.Provider value={this.state}>
        {this.props.children}
      </OrganizationContext.Provider>
    );
  };

  private getOrgnizationName = () => {
    return (
      (this.state.organization && this.state.organization.name) || 'Unknown'
    );
  };

  private setOrganization = (organization: IOrganization) => {
    return this.setState(state =>
      produce(state, draft => {
        draft.organization = organization;
      }),
    );
  };

  private updateOrganization = async () => {
    try {
      const { organizationId } = this.props;
      if (!organizationId) {
        return this.setState(state =>
          produce(state, draft => {
            draft.organization = undefined;
          }),
        );
      }

      this.setState(state =>
        produce(state, draft => {
          draft.loading = true;
        }),
      );

      const organization = await getOrganizationById(organizationId);

      if (!organization) {
        return this.setState(state =>
          produce(state, draft => {
            draft.organization = organization;
            draft.error = 'Organization not found';
          }),
        );
      }

      this.setState(state =>
        produce(state, draft => {
          draft.organization = organization;
        }),
      );
    } catch (e) {
      this.setState(state =>
        produce(state, draft => {
          draft.organization = undefined;
          draft.error = e as string | undefined;
        }),
      );
    } finally {
      this.setState(state =>
        produce(state, draft => {
          draft.loading = false;
        }),
      );
    }
  };
}
